import { Info } from 'lucide-react';

import { Label } from 'components/ui/label';
import { Switch } from 'components/ui/switch';

type SettingToggleFieldProps = {
  label: string;
  description?: string;
  checked: boolean;
  onCheckedChange: (value: boolean) => void;
  disabled?: boolean;
  showInfoIcon?: boolean;
};

export function SettingToggleField({
  label,
  description,
  checked,
  onCheckedChange,
  disabled,
  showInfoIcon = false,
}: Readonly<SettingToggleFieldProps>) {
  return (
    <div className="flex w-full items-start justify-between gap-4">
      <div className="min-w-0 flex-1 space-y-1 pr-2">
        <div className="flex items-center gap-2">
          <Label className="text-sm font-medium leading-snug text-foreground">{label}</Label>
          {showInfoIcon ? <Info className="h-4 w-4 shrink-0 text-muted-foreground" /> : null}
        </div>
        {description ? (
          <p className="text-sm leading-snug text-muted-foreground">{description}</p>
        ) : null}
      </div>
      <Switch
        checked={checked}
        onCheckedChange={onCheckedChange}
        disabled={disabled}
        className="mt-0.5 shrink-0"
      />
    </div>
  );
}
